<template>
  <div class="card">
    <div class="pd-0">
      <header class="bandeau-modal card-header">
      </header>
      <div class="card-content">
        <error-msg-component :messages="messagesPopup"
                             :error="isError"
                             :title="'general.problemOccurred'"
                             :withEmplyFields="true"
                             @close="isError = $event"/>
        <p class="is-size-3 has-text-weight-bold mgb-20px has-text-centered">
          {{ $t('dateDevis.headerAchat')}}
        </p>
        <div class="columns is-marginless is-paddingless card-content is-vcentered">
          <div class="column is-narrow pdl-0">
            <b-field :label="$t('general.du')">
            </b-field>
          </div>
          <b-datepicker show-week-number class="column is-narrow"
                        v-model="dateDebut"
                        icon="calendar-today"
                        nearby-selectable-month-days
                        :editable="true">
          </b-datepicker>
          <div class="column is-narrow">
            <b-field :label="$t('general.au')">
            </b-field>
          </div>
          <div class="column is-narrow">
            <b-datepicker show-week-number
                          v-model="dateFin"
                          icon="calendar-today"
                          nearby-selectable-month-days
                          position="is-bottom-left"
                          :editable="true">
            </b-datepicker>
          </div>
        </div>
        <main class="mgt-20px">
          <div class="is-grouped">
            <button
              class="button btn-modal-annuler is-cancel button-modal-decision"
              @click="$parent.close">
              {{ $t('general.button.cancel')}}
            </button>
            <button class="button is-addOrEdit button-modal-decision mgl-20px"
                    @click="updateDates()">
              {{ $t('general.button.valider')}}
            </button>
          </div>
        </main>
      </div>
    </div>
  </div>
</template>

<script>

import cloneDeep from 'lodash/cloneDeep';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import validationDate from '@/services/devisCommandes/validation/validationDateLocation';
import { CATEGORIE_LOCATION } from '@/configuration/catalogue/produitConf';
import moment from 'moment';

export default {
  props: {
    dates: {
      type: Object,
      required: true,
    },
    commandeAchatARapprocher: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      dateDebut: null,
      dateFin: null,
      isError: false,
      messagesPopup: [],
    };
  },
  components: {
    errorMsgComponent,
  },
  methods: {
    updateDates() {
      this.isError = false;
      this.messagesPopup = [];
      const errors = validationDate(
        this.dateDebut,
        this.dateFin,
        CATEGORIE_LOCATION,
      );
      if (errors.length > 0) {
        this.isError = true;
        this.messagesPopup = errors;
        return;
      }
      this.$emit('updateDates', {
        dateDebut: this.dateDebut,
        dateFin: this.dateFin,
      });
      this.$parent.close();
    },
  },
  mounted() {
    if (this.dates.dateDebut) this.dateDebut = new Date(cloneDeep(this.dates.dateDebut));
    if (this.dates.dateFin) this.dateFin = new Date(cloneDeep(this.dates.dateFin));
    if (!this.dateFin && !this.dateFin) {
      let dateDebut = null;
      let dateFin = null;
      this.commandeAchatARapprocher
        .filter((commandeARapprocher) => {
          return commandeARapprocher.montantAffecter > 0;
        })
        .forEach((commandeAchat) => {
          if (!dateDebut
            || moment(commandeAchat.echeanciers[0].dateDebut).isBefore(moment(dateDebut))) {
            dateDebut = moment(commandeAchat.echeanciers[0].dateDebut).toDate();
          }
          if (!dateFin
            || moment(commandeAchat.echeanciers[0].dateDebut).isAfter(moment(dateFin))) {
            dateFin = moment(commandeAchat.echeanciers[0].dateFin).toDate();
          }
        });
      this.dateDebut = dateDebut;
      this.dateFin = dateFin;
    }
  },
};

</script>
